// DESCRIPTION: Step 4 — notification toggles. Three switches: admin notify,
// customer confirmation, customer reminder. Templates configured later.

import { __ } from '@wordpress/i18n';
import WizardShell from '../components/WizardShell';

/**
 * @since PBOOKING_SINCE
 *
 * @param {Object}   props
 * @param {Object}   props.value      { admin_notify, customer_confirm, reminder }
 * @param {Function} props.onChange   (next) => void
 * @param {Function} props.onBack
 * @param {Function} props.onSkip
 * @param {Function} props.onContinue
 * @param {number}   props.progress
 * @param {boolean}  props.isLoading
 *
 * @return {JSX.Element}
 */
export default function NotificationsStep( {
	value,
	onChange,
	onBack,
	onSkip,
	onContinue,
	progress,
	isLoading,
} ) {
	const toggle = ( key ) => onChange( { ...value, [ key ]: ! value[ key ] } );

	const rows = [
		{
			key: 'admin_notify',
			title: __( 'Notify me when someone books', 'nemtly-booking' ),
			desc: __(
				'Email goes to the site admin address.',
				'nemtly-booking'
			),
		},
		{
			key: 'customer_confirm',
			title: __(
				'Send confirmation email to customer',
				'nemtly-booking'
			),
			desc: __(
				'Triggered immediately after a successful booking.',
				'nemtly-booking'
			),
		},
		{
			key: 'reminder',
			title: __( 'Send reminder email before event', 'nemtly-booking' ),
			desc: __(
				'Sent 24 hours before the event. Adjust later in Settings.',
				'nemtly-booking'
			),
		},
	];

	return (
		<WizardShell
			stepKey="notify"
			progress={ progress }
			onBack={ onBack }
			onSkip={ onSkip }
			onContinue={ onContinue }
			isLoading={ isLoading }
		>
			<div className="nemtly-wizard-step">
				<h2 className="nemtly-wizard-headline">
					{ __( 'Notifications', 'nemtly-booking' ) }
				</h2>
				<p className="nemtly-wizard-lede">
					{ __(
						'Pick which emails Nemtly should send. You can customize the wording later.',
						'nemtly-booking'
					) }
				</p>

				<div className="nemtly-wizard-toggles">
					{ rows.map( ( row ) => (
						<label key={ row.key } className="nemtly-wizard-toggle">
							<div className="nemtly-wizard-toggle__text">
								<span className="nemtly-wizard-toggle__title">
									{ row.title }
								</span>
								<span className="nemtly-wizard-toggle__desc">
									{ row.desc }
								</span>
							</div>
							<span
								className={ `nemtly-wizard-switch ${
									value[ row.key ] ? 'is-on' : 'is-off'
								}` }
								onClick={ () => toggle( row.key ) }
								role="switch"
								aria-checked={ value[ row.key ] }
								tabIndex={ 0 }
								onKeyDown={ ( e ) => {
									if ( e.key === ' ' || e.key === 'Enter' ) {
										e.preventDefault();
										toggle( row.key );
									}
								} }
							>
								<span className="nemtly-wizard-switch__thumb" />
							</span>
						</label>
					) ) }
				</div>
			</div>
		</WizardShell>
	);
}
